import type { ArticleInterface } from '~/types/AppData/PageContent/ArticleInterface';
import type { ArticleItemType } from '~/types/ArticleItemType';

// TODO: Remove this file with all its usages once the video placement experiments end.

/**
 * Checks for the "video-placement-mobile-fs" experiment.
 */
export function mobileVideoPlacementExperiment(
  experiments?: string[]
): boolean {
  return (
    mobileVideoBodyExperiment(experiments) ||
    mobileVideoCoverExperiment(experiments)
  );
}

export function mobileVideoBodyExperiment(experiments?: string[]): boolean {
  if (!experiments) return false;
  return experiments.includes('video-placement-mobile-fs|body');
}

export function mobileVideoCoverExperiment(experiments?: string[]): boolean {
  if (!experiments) return false;
  return experiments.includes('video-placement-mobile-fs|cover');
}

/**
 * Checks for the "video-placement-desktop-fs" experiment.
 */
export function desktopVideoPlacementExperiment(
  experiments?: string[]
): boolean {
  return (
    desktopVideoBodyExperiment(experiments) ||
    desktopVideoCoverExperiment(experiments)
  );
}

export function desktopVideoBodyExperiment(experiments?: string[]): boolean {
  if (!experiments) return false;
  return experiments.includes('video-placement-desktop-fs|body');
}

export function desktopVideoCoverExperiment(experiments?: string[]): boolean {
  if (!experiments) return false;
  return experiments.includes('video-placement-desktop-fs|cover');
}

/**
 * Returns true if the given item is a VideoPlayer component of a specific size.
 */
export function isVideoOfSize(
  item: ArticleItemType,
  size: 'sm' | 'lg'
): boolean {
  return (
    item.component === 'VideoPlayer' && item.options?.sizes?.includes(size)
  );
}

export function addVideoPlayerToBody(body: any, device: 'mobile' | 'desktop') {
  const videoPlayerBlock = {
    type: 'video-player',
    value: {
      sizes: device === 'mobile' ? ['sm', 'md'] : ['lg'],
    },
  };

  if (!body || !body.length) return [videoPlayerBlock];

  const [firstBlock, ...restBlocks] = body;
  return [firstBlock, videoPlayerBlock, ...restBlocks];
}

/**
 * Returns true if the video should be used as the cover.
 */
export function shouldUseVideoPlayerAsCover(
  article: Partial<ArticleInterface>,
  isMobileViewer: boolean,
  experiments?: string[]
): boolean {
  if (!experiments) return false;

  const noVideo = article.metadata?.commercialTags?.includes('no-video-player');
  if ((article.finiteScrollNumber ?? 0) > 0 || noVideo) return false;

  return (
    (!isMobileViewer && desktopVideoCoverExperiment(experiments)) ||
    (isMobileViewer && mobileVideoCoverExperiment(experiments))
  );
}
